export default __webpack_public_path__ + "static/heroku-firelog-65a0ec48429c02e2188f87b2e158f6ae.gif";